import React, { useState } from 'react';
import './CsvAnalysis.css';

interface CsvInputProps {
  onAnalyze: (csvData: string) => void;
  isLoading: boolean;
}

const CsvInput: React.FC<CsvInputProps> = ({ onAnalyze, isLoading }) => {
  const [csvData, setCsvData] = useState('');

  const handleSubmit = () => {
    if (csvData.trim()) {
      onAnalyze(csvData);
    } else {
      alert('Please paste or type CSV data into the text area.');
    }
  };

  return (
    <div className="csv-input-container">
      <h3>Paste CSV Data</h3>
      <textarea
        value={csvData}
        onChange={(e) => setCsvData(e.target.value)}
        placeholder="id,product,category,sales&#10;1,Laptop,Electronics,1200&#10;2,Shirt,Apparel,50"
        rows={15}
        className="dstack-textarea"
      />
      <button onClick={handleSubmit} disabled={isLoading} className="deriq-action-button analyze-button">
        {isLoading ? 'Analyzing...' : 'Analyze CSV'}
      </button>
    </div>
  );
};

export default CsvInput;